export enum ApplicationAuthorizationActionType {
  LoggedIn = 'Logged in',
  LoggedOut = 'Logged out',
  LoginFailed = 'Login failed',
  Registered = 'Registered',
  AccountCreated = 'Account Created',
  SignupError = 'Signup Error',
  RegistrationFailed = 'Registration failed',
  BusinessRegistrationOptionClicked = 'Business SignUp Option Clicked',
  TierTwoRegistrationStepFailed = 'Tier2 registration step failed',
  LegalAddressCreated = 'Use Legal Address as billing and shipping',
  EmailCheckSubmitted = 'Email Check Submitted',
  DestinationLogin = 'Login',
  DestinationPasswordlessLogin = 'Login - Passwordless',
  DestinationRegister = 'Register',
  AutologinRequest = 'IDAM Autologin request',
  MagicLinkEmailRedirect = 'Magic Link Email Redirect',
  ResendLoginLinkClicked = 'Resend login link Clicked',
  CombinedLoginSignup = 'Combined Login/Signup',
  MagicLinkFlow = 'Magic Link Flow',
  ChooseLoginOptionClick = 'Choose Login Option Click',
  EmailAlreadyExists = 'Signup - User ID Already Exists Popup',
  PasswordLessSignupClick = 'Passwordless Flow Signup Button Click',
  SelectKvkBranch = 'Select KvK Branch',
  SetPassword = 'Set Password',
  BlockedTaxNumber = 'Blocked Tax Number',
}

export enum AutologinAuthorizationLabel {
  Ok = 'ok',
  Fail = 'fail',
}

export enum MagicLinkAuthorizationLabel {
  Success = 'Success',
  Expired = 'Expired',
}

export enum MagicLinkFlowLabel {
  Success = 'Success',
  Failed = 'Failed',
}

export enum ResetPasswordLabel {
  Success = 'Success',
  Failed = 'Failed',
  ClickSuccess = 'Click - Success',
  ClickFail = 'Click - Fail',
}

export enum RegistrationTypeLabels {
  Personal = 'Personal',
  Business = 'Business',
  Metro = 'Business Metro Card',
}

export enum LoginFlowLabels {
  PasswordlessLogin = 'Passwordless Login',
  PasswordLogin = 'Password Login',
}

export enum KvkAuthorizationLabels {
  FailedBusiness = '{ kvkNumber - Failed Business }',
}

export enum LoginEventsLabel {
  SuccessNormalLogin = 'Success - Normal Login',
  FailNormalLogin = 'Fail - Normal Login',
  SuccessSilentRefresh = 'Success - Silent Refresh',
  FailSilentRefresh = 'Fail - Silent Refresh',
  SuccessAutoLogin = 'Success - Auto Login with valid token',
  FailAutoLogin = 'Fail - Auto Login with valid token',
}

export enum LoginType {
  NormalLogin = 'normal login',
  AutoLogin = 'auto login',
}

export enum BlockedTaxNumberLabel {
  HotelGroupTaxNumber = 'Hotel Group Tax Number',
}
